var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prd-cate-w"},[_c('category-filter',{on:{"filterInfo":_vm.getDataByFilter}}),_c('gds-list',{attrs:{"outerFilter":_vm.headFilter}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }